export default function HelpPage() {
  return (
    <div
      className="min-h-screen flex items-start justify-center px-6 py-16"
      style={{ background: "var(--bg)" }}
    >
      <article
        style={{
          maxWidth: 720,
          width: "100%",
          display: "grid",
          gap: "clamp(16px, 4vw, 24px)",
        }}
      >
      <header>
        <h1 className="mono" style={{ letterSpacing: "0.18em", textTransform: "uppercase" }}>Help & Support</h1>
        <p className="small" style={{ textTransform: "none", color: "var(--muted)" }}>
          Reach the Factory/Zen ops crew via support@salesdemon.ai or text HELP to your demon&apos;s number any time.
        </p>
      </header>
      <section>
        <h2 className="mono" style={{ letterSpacing: "0.12em", textTransform: "uppercase" }}>Quiet hours</h2>
        <p className="small" style={{ textTransform: "none", color: "var(--muted)" }}>
          Reply STOP to pause messaging, START to resume, and HELP for quick guidance. Quiet hours can be configured
          inside Settings.
        </p>
      </section>
      <section>
        <h2 className="mono" style={{ letterSpacing: "0.12em", textTransform: "uppercase" }}>Emergency</h2>
        <p className="small" style={{ textTransform: "none", color: "var(--muted)" }}>
          For payment disputes or critical escalations, call +1 (415) 555-0138 and reference your tenant name.
        </p>
      </section>
      </article>
    </div>
  )
}
